export function trackShareContent(shareMedium, item) {
  const VALID_SHARE_MEDIA = ['facebook', 'whatsapp', 'email', 'twitter', 'copy-link-button'];

  if (VALID_SHARE_MEDIA.indexOf(shareMedium) === -1) {
    return;
  }

  window.Taq.push([
    'track',
    'link',
    {
      event_name: `share_${shareMedium}`,
      event_category: 'share',
      event_action: shareMedium || null,
      social_target: item || null,
      social_network: shareMedium || null,
      social_action: 'share',
    },
  ]);
}

export function trackOpenShareMenu() {
  window.Taq.push([
    'track',
    'link',
    {
      event_name: 'share_menu',
      event_category: 'share',
      event_action: 'open_menu',
    },
  ]);
}
